<dackl-filter-multi-select
  label="Programme"
  [options]="(filterOptions$ | async) ?? []"
  (optionsChanged)="updateOptions($event)"
  showItemSearch
></dackl-filter-multi-select>
